import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import { IonCard, IonImg } from "@ionic/react";
import "@ionic/react/css/ionic-swiper.css";
import { useState } from "react";
import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/navigation";
import "swiper/css/pagination";
import introImg from "../assets/graphics/intro-1.png";
import "./CardSlides.css";
import AnimationContainer from "./Animation";

interface CardSlidesProps {
  onSwipe?: any;
}

const slides = [
  {
    img: null,
    lottie: "smartControlAnimation",
    title:
      "QuidPro offers both experts and newbies the worlds first play to earn cryptocurrency trading game"
  },
  {
    img: introImg,
    lottie: "learningAnimation",
    title:
      "Keep a book of your favourite strategies or star the most profitable strategies you discover."
  },
  {
    img: introImg,
    lottie: "blueprintAnimation",
    title:
      "Test strategies and prevent losses by simulating trades with historical data, risk-free."
  }
];

const getSampleSlide = (slide: any, index: number, activeIndex: number) => {
  const isNextSlide = index === activeIndex + 1;
  const isBeforeSlide = index === activeIndex - 1;

  return (
    <SwiperSlide key={`slide-${index}`} className="w-md">
      <div className="mb-14">
        <IonCard className="h-64 w-64 mx-12 mb-10 bg-primary-80 rounded-2xl ion-no-padding transition-all duration-500 flex justify-center items-center">
          {slide?.lottie ? (
            <AnimationContainer animationName={slide?.lottie} />
          ) : (
            <IonImg src={slide.img} />
          )}
        </IonCard>
        <div
          className={`text-base mx-10 text-white/80 ion-text-center 
          ${isNextSlide ? "hidden" : ""} ${isBeforeSlide ? "hidden" : ""}
          `}
        >
          {slide.title}
        </div>
      </div>
    </SwiperSlide>
  );
};

const CardSlides: React.FC<CardSlidesProps> = ({ onSwipe }) => {
  // eslint-disable-next-line
  const [swiper, setSwiper] = useState<any>();
  return (
    <Swiper
      modules={[Pagination]}
      pagination={{ clickable: true }}
      slidesPerView={1.3}
      centeredSlides={true}
      spaceBetween={20}
      className="max-w-md mb-6"
      onSwiper={(swiper: any) => {
        setSwiper(swiper);
        onSwipe(swiper.activeIndex);
      }}
      onSlideChange={() => {
        onSwipe(swiper.activeIndex);
      }}
    >
      {slides.map((slide, index) =>
        getSampleSlide(slide, index, swiper?.activeIndex)
      )}
    </Swiper>
  );
};

export default CardSlides;
